<template>
  <b-media
    v-if="data && JSON.stringify(data) !== '[]' && data !== null && data !== ''"
    class="d-flex flex-column"
    no-body
  >
    <b-media-aside>
      <b-link>
        <b-button
          variant="primary"
          v-if="isPdfFile(data)"
          href="#0"
          @click="pdf(getFileUrl(data))"
          size="sm"
        >
          Show PDF
        </b-button>
        <b-img
          v-else-if='data'
          rounded
          @click="pdf(getFileUrl(data))"
          :src="getFileUrl(data)"
          style="width: 200px; height: 150px"
        />
      </b-link>
    </b-media-aside>
  </b-media>
</template>
<script>
import { BMedia, BMediaAside, BLink, BImg, BButton } from "bootstrap-vue";
// import PDFViewer from 'pdf-viewer-vue'

export default {
  props: ["data"],
  data(){
    return{
      imagePath: process.env.VUE_APP_IMAGE_PATH
    }
  },
  components: {
    BButton,
    // PDFViewer,
    BMedia,
    BMediaAside,
    BLink,
    BImg,
  },
  methods: {
    pdf(data) {
      window.open(`${data}`);
    },
    isPdfFile(data) {
      if (!data) return false;
      const dataStr = typeof data === 'string' ? data : JSON.stringify(data);
      return dataStr.toLowerCase().includes('.pdf') || dataStr.toLowerCase().includes('pdf');
    },
    getFileUrl(data) {
      if (!data) return '';
      
      // If data is a full URL (starts with http:// or https://), use it as-is
      if (typeof data === 'string' && (data.startsWith('http://') || data.startsWith('https://'))) {
        return data;
      }
      
      // If data already includes the imagePath, use it as-is
      if (typeof data === 'string' && data.includes(this.imagePath)) {
        return data;
      }
      
      // Otherwise, prepend the imagePath
      return this.imagePath + data;
    },
  },
};
</script>
